export const ArticleItems = [
  {
    publisher: "Geek Culture",
    title:
      "Demystifying Object-Oriented Programming in a Software Architect Perspective",
    summary: "The Power of OO lies in Polymorphism And Dependency Inversion",
    url: "https://medium.com/geekculture/demystifying-object-oriented-programming-in-a-software-architect-perspective-4191186aebe2",
  },
  {
    publisher: "Geek Culture",
    title: "Docker Basics and Easy Steps to Dockerize Spring Boot Application",
    summary:
      "Wouldn’t it be lovely if you can magically encapsulate your environment along with your code and share or deploy it as a whole package?",
    url: "https://medium.com/geekculture/docker-basics-and-easy-steps-to-dockerize-spring-boot-application-17608a65f657",
  },
  {
    publisher: "The Startup",
    title:
      "Java Chapter 1 : Anonymous Class, Functional Interface, and Lambda Expression",
    summary: "You probably use Lambda Expression. But do you know what it is?",
    url: "https://medium.com/swlh/super-basic-java-anonymous-class-functional-interface-and-lambda-expression-fba411a787",
  },
  {
    publisher: "The Startup",
    title:
      "Java Chapter 2 : Why Functional Programming in Object-Oriented Programming",
    summary:
      "Functional Interface and Lambda Expression add syntactic sugar to our code. Is this all they offer?",
    url: "https://levelup.gitconnected.com/super-java-functional-programming-in-object-oriented-programming-84dab44a915f",
  },
  {
    publisher: "The Startup",
    title: "Java Chapter 3 : How to Shift to Functional Programming in Java",
    summary: "From declarative to imperative programming",
    url: "https://medium.com/swlh/super-java-how-to-shift-to-functional-programming-in-java-a13d3176cc61",
  },
  {
    publisher: "The Startup",
    title: "Beginner’s guide to Flutter Web — Set up To Deployment",
    summary:
      "Flutter is amazing! You can build iOS apps and android apps with one codebase. Although it is yet in the beta channel, Flutter also…",
    url: "https://kim66s.medium.com/beginners-guide-to-flutter-web-set-up-to-deployment-39c967d7dfae",
  },
];
